import { Box, Button, TextField, MenuItem } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
import Header from "../../components/Header";
import { useState, useEffect } from "react";
import LoadingSpinner from "../../loadingSpinner";
import ModalSucces from "../../modal/modalSucces";
import ModalError from "../../modal/modalError";
import ModalCharge from "../../modal/modalCharge";
import {getApiBaseUrl} from '../../utils/getApiBaseUrl';
import ModalUserData from "../../modal/user/modalUserData";
import { getOneUsuario } from "../../services/user.services";
import ModalCalculoDias from "../../modal/faltas/modalCalculodia";
import { Visibility } from "@mui/icons-material";
import { postDatosFaltas } from "../../services/faltas.services";
import ModalCalculoHoras from "../../modal/faltas/modalCalculohora";
import * as Yup from "yup";
import { getOneHorarios } from "../../services/horarios.services";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import secureStorage from "../../utils/secureStorage";


const Faltas = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [registrationSuccess, setRegistrationSuccess] = useState(false);
    const [registrationError, setRegistrationError] = useState(false);
    const [error, setError] = useState("");

    // Estados dinámicos
    const [tipo, setTipo] = useState(""); // AUSENCIA | PERMISO
    const [subtipo, setSubtipo] = useState(""); // JUSTIFICADO | INJUSTIFICADO | PERMISO_POR_DIA | PERMISO_POR_HORA
    const [remunerado, setRemunerado] = useState("");
    const [salario, setSalario] = useState(null);
    const [descuento, setDescuento] = useState(0);
    const [openUserModal, setOpenUserModal] = useState(false);
    const [openCalculoModal, setOpenCalculoModal] = useState(false);
    const [openCalculoModalHoras, setOpenCalculoModalHoras] = useState(false);
    const [puedeRegistrar, setPuedeRegistrar] = useState(false);
    const puedeAbrirModalPermiso = tipo === "PERMISO" && remunerado !== "";
    const [selectedUser, setSelectedUser] = useState(null); // usuario elegido desde ModalUserData
    const [calculoData, setCalculoData] = useState({
        sueldo: 0,
        sueldoDia: 0,
        dias: 0,
        descuento: 0,
        fecha_inicio: "",
        fecha_fin: ""
    });

    const [calculoHoras, setCalculoHoras] = useState({
        sueldo: 0,
        sueldoDia: 0,
        valorHora: 0,
        hora_inicio: "",
        hora_fin: "",
        fecha: "",
        minutos: 0,
        horas: 0,
        descuento: 0,
        descontarAlmuerzo: false
    });


  // Traer salario del usuario logueado
    const USER = secureStorage.getItem("id");


  const calcularDescuentoAusencia = (inicio, fin) => {
    if (!salario || !inicio || !fin) return;

    const fechaInicio = new Date(inicio);
    const fechaFin = new Date(fin);

    const dias =
      (fechaFin - fechaInicio) / (1000 * 60 * 60 * 24) + 1;

    const salarioDiario = salario / 30;
    const d = Math.round(salarioDiario * dias);

    setDescuento(d);
  };

    const fetchSalarioUsuario = async (idUser) => {
        try {
            const data = await getOneUsuario(idUser);

            const idHorario = data.id_horarios;


            setCalculoData(prev => ({
                ...prev,
                sueldo: data.salario_externo,
                sueldoDia: data.salario_externo / 30
            })); 

            setCalculoHoras(prev => ({
              ...prev,
              sueldo: data.salario_externo,
              sueldoDia: data.salario_externo / 30,
              valorHora: (data.salario_externo / 30) / 8
            }));

              if (idHorario) {
                await fetchHorarioUsuario(idHorario);
              }

            

        } catch (error) {
            console.error("Error al traer salario del usuario", error);
        }
    };

    const fetchHorarioUsuario = async (idHorario) => {
    try {
        const data = await getOneHorarios(idHorario);

        setCalculoHoras(prev => ({
            ...prev,
            minutosAlmuerzo: data.almuerzo || 0,
        }));
    } catch (error) {
        console.error("Error al traer horarios del usuario", error);
    }
};



  const handleFormSubmit = async (values, { resetForm }) => {
    setIsLoading(true);

    try {
      const tipoFinal =
        tipo === "DESCONTAR"
        ? "DESCONTAR"
        : tipo === "AUSENCIA"
        ? "AUSENCIA"
        : subtipo === "PERMISO_POR_DIA"
        ? "PERMISO_POR_DIA"
        : "PERMISO_POR_HORA";

      const payload = {
        id_usuario: selectedUser.id,
        created_by: Number(USER),
        tipo: tipoFinal,
    
        fecha_inicio: values.fecha_inicio || null,
        fecha_fin: values.fecha_fin || null,
        hora_inicio: values.hora_inicio || null,
        hora_fin: values.hora_fin || null,
    
        dias: values.dias || null,
        horas: values.horas || null,

    
        monto_descuento: values.monto || 0,
    
        justificado:
          tipo === "PERMISO" || tipo === "DESCONTAR"
            ? 1
            : values.justificado === "JUSTIFICADO"
              ? 1
              : 0,

        obs: values.obs || "",
        remunerado: remunerado || "NO_REMUNERADO",

      };

  try {
    const response = await postDatosFaltas(payload);
    setRegistrationSuccess(true);
  } catch (error) {
    console.error("error sending data", error);
    setRegistrationError(true);
    setError(error.message);
  };

      resetForm();

      // 🔥 Reset de todos los estados externos
      setTipo("");
      setSubtipo("");
      setRemunerado("");
      setSelectedUser(null);
      setPuedeRegistrar(false);
      setDescuento(0);

      setCalculoData({
        sueldo: 0,
        sueldoDia: 0,
        dias: 0,
        descuento: 0,
        fecha_inicio: "",
        fecha_fin: ""
      });

      setCalculoHoras({
        sueldo: 0,
        sueldoDia: 0,
        valorHora: 0,
        hora_inicio: "",
        hora_fin: "",
        fecha: "",
        minutos: 0,
        horas: 0,
        descuento: 0,
        descontarAlmuerzo: false
      });
    } catch (error) {
      console.error(error);
      setRegistrationError(true);
      setError(error.message);
    } finally {
      setTimeout(() => setIsLoading(false), 1000);
    }
  };

  return (
    <Box m="20px">
      <Header title="Registrar Falta" subtitle="Control de Ausencias y Permisos" />

      {isLoading && <LoadingSpinner />}
      <ModalSucces open={registrationSuccess} onClose={() => setRegistrationSuccess(false)} />
      <ModalError open={registrationError} onClose={() => setRegistrationError(false)} error={error} />
      <ModalCharge isLoading={isLoading} />

      <Formik
        onSubmit={handleFormSubmit}
        initialValues={{
            funcionario: "",
            tipo: "",
            justificado: "",
            obs: "",
            fecha_inicio: "",
            fecha_fin: "",
            fecha_unica: null, 
            permisoTipo: "",
            permiso_fecha_inicio: "",
            permiso_fecha_fin: "",
            permiso_hora_fecha: "",
            hora_inicio: "",
            hora_fin: "",
            monto: "",
        }}
        validationSchema={checkoutSchema}
      >
        {({ values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px" gridTemplateColumns="repeat(4, minmax(0, 1fr))">
                    <TextField
                        fullWidth
                        label="Funcionario"
                        value={selectedUser ? `${selectedUser.firstname} ${selectedUser.lastname}` : ""}
                        onClick={() => setOpenUserModal(true)}
                        InputProps={{ readOnly: true }}
                        name="funcionario"
                        error={!!touched.funcionario && !!errors.funcionario}
                        helperText={touched.funcionario && errors.funcionario}
                        sx={{ gridColumn: "span 4" }}
                    />

              {/* Tipo general */}
                <TextField
                  select
                  fullWidth
                  label="Tipo"
                  name="tipo"
                  value={values.tipo}
                  onChange={(e) => {
                    handleChange(e);
                    setTipo(e.target.value);           // <-- NECESARIO
                    setSubtipo(""); 
                    setFieldValue("justificado", "");
                    setFieldValue("permisoTipo", "");
                  }}
                  error={!!touched.tipo && !!errors.tipo}
                  helperText={touched.tipo && errors.tipo}
                  sx={{ gridColumn: "span 4" }}
                >
                  <MenuItem value="AUSENCIA">Ausencia</MenuItem>
                  <MenuItem value="PERMISO">Permiso</MenuItem>
                  <MenuItem value="DESCONTAR">Descontar</MenuItem>
                </TextField>


              {/* AUSENCIA */}
              {tipo === "AUSENCIA" && (
                <>
                  <TextField
                    select
                    fullWidth
                    label="Justificación"
                    name="justificado"
                    value={values.justificado}
                    onChange={handleChange}
                    onBlur={handleBlur}   // 👈 importante para que Formik marque touched
                    error={!!touched.justificado && !!errors.justificado}
                    helperText={touched.justificado && errors.justificado}

                    sx={{ gridColumn: "span 4" }}
                  >
                    <MenuItem value="JUSTIFICADO">Justificado</MenuItem>
                    <MenuItem value="INJUSTIFICADO">Injustificado</MenuItem>
                  </TextField>

                  {values.justificado === "JUSTIFICADO" && (
                    <TextField
                        fullWidth
                        label="Observación"
                        name="obs"
                        multiline
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.obs}
                        error={!!touched.obs && !!errors.obs}
                        helperText={touched.obs && errors.obs}
                        sx={{ gridColumn: "span 4" }}
                    />
                )}
                  <Button
                    variant="contained"
                    color="secondary"
                    disabled={
                      !selectedUser ||                          // debe tener usuario
                      values.justificado === "JUSTIFICADO" && !values.obs.trim() ||
                      !values.justificado
                    }
                    onClick={() => {
                        setPuedeRegistrar(false);  // ❗ Se deshabilita hasta confirmar de nuevo
                        setOpenCalculoModal(true);
                    }}
                    sx={{ 
                        minWidth: "5px",
                        width: "80px",
                        padding: "4px",
                    }}
                    >
                        <Visibility sx={{ fontSize: 30 }} />
                    </Button>

                </>
              )}

              {/* PERMISO */}
              {tipo === "PERMISO" && (
                <>
                  <TextField
                    fullWidth
                    label="Observación"
                    name="obs"
                    multiline
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.obs}
                    error={!!touched.obs && !!errors.obs}
                    helperText={touched.obs && errors.obs}
                    sx={{ gridColumn: "span 4" }}
                  />
                  <TextField
                    select
                    fullWidth
                    label="Tipo de permiso"
                    value={subtipo}
                    onBlur={handleBlur}
                    error={!!touched.permisoTipo && !!errors.permisoTipo}
                    helperText={touched.permisoTipo && errors.permisoTipo}

                    onChange={(e) => {
                        setSubtipo(e.target.value);
                        setFieldValue("permisoTipo", e.target.value); // <--- IMPORTANTE
                      }}
                    sx={{ gridColumn: "span 4" }}
                  >
                    <MenuItem value="PERMISO_POR_DIA">Por día</MenuItem>
                    <MenuItem value="PERMISO_POR_HORA">Por hora</MenuItem>
                  </TextField>

                  {tipo === "PERMISO" && (subtipo === "PERMISO_POR_DIA" || subtipo === "PERMISO_POR_HORA") && (
                    <TextField
                      select
                      fullWidth
                      label="Remuneración"
                      value={remunerado}
                      onChange={(e) => setRemunerado(e.target.value)}
                      sx={{ gridColumn: "span 4" }}
                    >
                      <MenuItem value="REMUNERADO">Remunerado (sin descuento)</MenuItem>
                      <MenuItem value="NO_REMUNERADO">No remunerado</MenuItem>
                    </TextField>
                  )}

                    <Box sx={{ gridColumn: "span 4" }}>
                        <Button
                          variant="contained"
                          color="secondary"
                          disabled={
                            !selectedUser ||
                            !puedeAbrirModalPermiso ||
                            !values.obs.trim()   // obligatorio siempre en permiso
                          }
                          onClick={() => {
                            if (subtipo === "PERMISO_POR_DIA") {
                                setOpenCalculoModal(true);
                            } else if (subtipo === "PERMISO_POR_HORA") {
                                setOpenCalculoModalHoras(true);
                            }
                          }}
                        >
                          <Visibility sx={{ fontSize: 30 }} />
                        </Button>

                    </Box>

                </>
              )}

              {/* DESCONTAR */}
              {tipo === "DESCONTAR" && (
                <>
                  <TextField
                    fullWidth
                    label="Motivo del descuento"
                    name="obs"
                    multiline
                    value={values.obs}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!touched.obs && !!errors.obs}
                    helperText={touched.obs && errors.obs}
                    sx={{ gridColumn: "span 4" }}
                  />

                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                      label="Fecha"
                      value={values.fecha_unica}
                      onChange={(newValue) => {
                        setFieldValue("fecha_unica", newValue);
                        setFieldValue("fecha_inicio", newValue);
                        setFieldValue("fecha_fin", newValue);
                      }}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          error: !!touched.fecha_unica && !!errors.fecha_unica,
                          helperText: touched.fecha_unica && errors.fecha_unica,
                        },
                      }}
                    />
                  </LocalizationProvider>
                    
                  <TextField
                    fullWidth
                    type="number"
                    label="Monto a descontar"
                    name="monto"
                    value={values.monto}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    error={!!touched.monto && !!errors.monto}
                    helperText={touched.monto && errors.monto}
                    sx={{ gridColumn: "span 1" }}
                  />

                  <Button
                    variant="contained"
                    color="secondary"
                    size="small"
                    sx={{ height: "5vh",
                    width: "5vw",        // ancho fijo más chico
                      borderRadius: "8px",
                      padding: "4px 12px", }}
                    disabled={
                      !selectedUser ||
                      !values.obs?.trim() ||
                      !values.monto ||
                      !values.fecha_inicio
                    }
                    onClick={() => setPuedeRegistrar(true)}
                  >
                    Confirmar
                  </Button>
                </>
              )}


            </Box>

            <Box display="flex" justifyContent="end" mt="20px">
              <Button
                type="submit"
                variant="contained"
                disabled={!puedeRegistrar}
                sx={{
                  backgroundColor: "rgb(206, 220, 0)",
                  color: "black",
                  height: "7vh",
                  width: "10vw",
                  borderRadius: "20px",
                  "&:hover": { backgroundColor: "#bac609" },
                }}
              >
                Registrar
            </Button>
               
                <ModalUserData
                  open={openUserModal}
                  onClose={() => setOpenUserModal(false)}
                    onSelectUsuario={(user) => {
                        setSelectedUser(user);
                        setFieldValue("funcionario", user.id);

                        // 🔥 Reset datos dependientes
                        setCalculoData({
                            sueldo: 0,
                            sueldoDia: 0,
                            dias: 0,
                            descuento: 0,
                            fecha_inicio: "",
                            fecha_fin: ""
                        });
                    
                        setDescuento(0);
                        setTipo("");
                        setSubtipo("");
                        setRemunerado("");
                        setPuedeRegistrar(false);
                    
                        fetchSalarioUsuario(user.id);
                        setOpenUserModal(false);
                    }}

                />
                <ModalCalculoDias
                    open={openCalculoModal}
                    onClose={() => setOpenCalculoModal(false)}
                    selectedUser={selectedUser}
                    calculoData={calculoData}
                    setCalculoData={setCalculoData}
                    remunerado={remunerado}
                    onConfirm={() => {
                        values.fecha_inicio = calculoData.fecha_inicio;
                        values.fecha_fin = calculoData.fecha_fin;
                        values.dias = calculoData.dias;

                        if (tipo === "PERMISO") {
                            if (remunerado === "REMUNERADO") {
                                // Permiso remunerado → 0 descuento
                                calculoData.descuento = 0;
                                setDescuento(0);
                            } else {
                                // No remunerado → descuento calculado
                                setDescuento(calculoData.descuento);
                            }
                        }

                        setPuedeRegistrar(true);
                    
                        setOpenCalculoModal(false);
                    }}
                />
                  <ModalCalculoHoras
                    open={openCalculoModalHoras}
                    onClose={() => setOpenCalculoModalHoras(false)}
                    selectedUser={selectedUser}
                    calculoHoras={calculoHoras}
                    setCalculoHoras={setCalculoHoras}
                    remunerado={remunerado} 
                    onConfirm={() => {

                        // Guardamos valores en Formik
                        setFieldValue("hora_inicio", calculoHoras.hora_inicio);
                        setFieldValue("hora_fin", calculoHoras.hora_fin);
                        setFieldValue("horas", calculoHoras.horas);
                        setFieldValue("monto", calculoHoras.descuento);
                    
                        setPuedeRegistrar(true);
                        setOpenCalculoModalHoras(false);
                    }}
                  />

            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

const checkoutSchema = yup.object().shape({
  funcionario: yup.number().required("Debes seleccionar un funcionario"),

  tipo: yup.string()
    .oneOf(["AUSENCIA", "PERMISO", "DESCONTAR"], "Tipo inválido")
    .required("Debes seleccionar el tipo"),

  justificado: yup.string().when("tipo", {
    is: "AUSENCIA",
    then: (schema) =>
      schema
        .oneOf(["JUSTIFICADO", "INJUSTIFICADO"], "Debes elegir")
        .required("Debes seleccionar si es justificado"),
    otherwise: (schema) => schema.notRequired(),
  }),

  obs: yup.string().when(["tipo", "justificado"], {
    is: (tipo, justificado) => tipo === "AUSENCIA" && justificado === "JUSTIFICADO",
    then: (schema) => schema.required("Debes ingresar una observación"),
    otherwise: (schema) => schema.notRequired(),
  }),

  fecha_inicio: yup.date().when("tipo", {
    is: "AUSENCIA",
    then: (schema) => schema.required("Selecciona fecha de inicio"),
    otherwise: (schema) => schema.notRequired(),
  }),

  fecha_fin: yup.date().when("tipo", {
    is: "AUSENCIA",
    then: (schema) =>
      schema.required("Selecciona fecha de fin")
            .min(yup.ref("fecha_inicio"), "La fecha fin no puede ser menor"),
    otherwise: (schema) => schema.notRequired(),
  }),

    permisoTipo: yup.string().when("tipo", {
      is: "PERMISO",
      then: schema =>
        schema.oneOf(
          ["PERMISO_POR_DIA", "PERMISO_POR_HORA"],
          "Debe seleccionar tipo de permiso"
        ).required("Selecciona el tipo de permiso"),
      otherwise: schema => schema.notRequired()
    }),


  permiso_fecha_inicio: yup.date().when(["tipo", "permisoTipo"], {
    is: (tipo, permisoTipo) => tipo === "PERMISO" && permisoTipo === "DIA",
    then: (schema) => schema.required("Selecciona fecha de inicio"),
    otherwise: (schema) => schema.notRequired(),
  }),

  permiso_fecha_fin: yup.date().when(["tipo", "permisoTipo"], {
    is: (tipo, permisoTipo) => tipo === "PERMISO" && permisoTipo === "DIA",
    then: (schema) =>
      schema
        .required("Selecciona fecha de fin")
        .min(yup.ref("permiso_fecha_inicio"), "Fecha fin inválida"),
    otherwise: (schema) => schema.notRequired(),
  }),

  permiso_hora_fecha: yup.date().when(["tipo", "permisoTipo"], {
    is: (tipo, permisoTipo) => tipo === "PERMISO" && permisoTipo === "HORA",
    then: (schema) => schema.required("Selecciona la fecha"),
    otherwise: (schema) => schema.notRequired(),
  }),

  hora_inicio: yup.string().when(["tipo", "permisoTipo"], {
    is: (tipo, permisoTipo) => tipo === "PERMISO" && permisoTipo === "HORA",
    then: (schema) => schema.required("Selecciona hora de inicio"),
    otherwise: (schema) => schema.notRequired(),
  }),

  hora_fin: yup.string().when(["tipo", "permisoTipo"], {
    is: (tipo, permisoTipo) => tipo === "PERMISO" && permisoTipo === "HORA",
    then: (schema) => schema.required("Selecciona hora fin"),
    otherwise: (schema) => schema.notRequired(),
  }),
  monto: yup.number().when("tipo", {
  is: "DESCONTAR",
  then: schema =>
    schema.required("Debes ingresar el monto a descontar")
          .positive("Debe ser mayor a 0"),
  otherwise: schema => schema.notRequired()
  }),

  fecha_unica: yup
  .mixed()
  .when("tipo", {
    is: "DESCONTAR",
    then: schema => schema.required("Debes seleccionar la fecha"),
    otherwise: schema => schema.notRequired(),
  }),


  obs: yup.string().when("tipo", {
    is: "DESCONTAR",
    then: schema => schema.required("Debes indicar el motivo del descuento"),
    otherwise: schema => schema.notRequired()
  }),
});




export default Faltas;
